/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component(props, {
  $f7,
  $f7router,
  $update
}) {
  let name = '';
  let email = '';
  let password = '';
  let confirmPassword = '';
  let loading = false;
  const nameChanged = function (event) {
    name = event.target.value;
  };
  const emailChanged = function (event) {
    email = event.target.value;
  };
  const passwordChanged = function (event) {
    password = event.target.value;
  };
  const confirmPasswordChanged = function (event) {
    confirmPassword = event.target.value;
  };
  const signup = async function (event) {
    event.preventDefault();
    if (loading) {
      return;
    }
    name = name.trim();
    email = email.trim().toLowerCase();
    if (!name) {
      $f7.dialog.alert('कृपया अपना नाम दर्ज करें।', 'साइन अप');
      return;
    }
    if (!email) {
      $f7.dialog.alert('कृपया अपना ईमेल दर्ज करें।', 'साइन अप');
      return;
    }
    if (password.length < 8) {
      $f7.dialog.alert('पासवर्ड कम से कम 8 अक्षरों का होना चाहिए।', 'पासवर्ड');
      return;
    }
    if (password !== confirmPassword) {
      $f7.dialog.alert('दोनों पासवर्ड समान होने चाहिए।', 'पासवर्ड');
      return;
    }
    loading = true;
    $update();
    try {
      const response = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: name,
          email: email,
          password: password
        })
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'खाता बनाने में समस्या हुई।');
      }
      $f7router.navigate('/verify/?email=' + encodeURIComponent(email));
    } catch (error) {
      console.error('SIGNUP ERROR:', error);
      $f7.dialog.alert(error.message || 'खाता नहीं बनाया जा सका।', 'साइन अप समस्या');
    } finally {
      loading = false;
      $update();
    }
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page login-page">
        <div class="login-content">

            <div class="login-brand">
                <div class="login-logo">P</div>
                <div class="login-title">पथक</div>
                <div class="login-subtitle">
                    गांव की प्रगति, सबकी भागीदारी
                </div>
            </div>

            <div class="login-card">

                <div class="login-heading">
                    नया खाता बनाएं
                </div>

                <div class="login-description">
                    ग्राम प्रगति से जुड़ने के लिए विवरण भरें
                </div>

                <form class="login-form" @submit=${signup}>

                    <div class="login-field">
                        <i class="material-icons">person</i>

                        <input
                            type="text"
                            name="name"
                            placeholder="पूरा नाम"
                            autocomplete="name"
                            @input=${nameChanged}
                            maxlength="150"
                            required
                            autofocus
                        />
                    </div>

                    <div class="login-field">
                        <i class="material-icons">email</i>

                        <input
                            type="email"
                            name="email"
                            placeholder="ईमेल पता"
                            autocomplete="email"
                            @input=${emailChanged}
                            required
                        />
                    </div>

                    <div class="login-field">
                        <i class="material-icons">lock</i>

                        <input
                            type="password"
                            name="password"
                            placeholder="पासवर्ड"
                            autocomplete="new-password"
                            @input=${passwordChanged}
                            required
                        />
                    </div>

                    <div class="login-field">
                        <i class="material-icons">lock_reset</i>

                        <input
                            type="password"
                            name="confirmPassword"
                            placeholder="पासवर्ड दोबारा दर्ज करें"
                            autocomplete="new-password"
                            @input=${confirmPasswordChanged}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        class="button button-fill login-button"
                        disabled=${loading}
                    >
                        <span class="login-button-text">
                            ${loading
                                ? 'खाता बनाया जा रहा है...'
                                : 'साइन अप करें'}
                        </span>
                    </button>

                    <div class="login-back">
                        <a href="/login/">
                            ← लॉगिन पर वापस जाएं
                        </a>
                    </div>

                </form>

            </div>

        </div>
    </div>
`
    }
    ;
}
framework7Component.id = 'dbb86cf0a9';
framework7Component.style = `
.login-page {
    background: #f7f4f0;
}

.login-content {
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
}

.login-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 18px;
    text-align: center;
}

.login-logo {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 7px;
    border-radius: 50%;
    background: #d94b05;
    color: #fff;
    font-size: 25px;
    font-weight: 700;
}

.login-title {
    color: #28231f;
    font-size: 25px;
    line-height: 1.1;
    font-weight: 700;
}

.login-subtitle {
    margin-top: 5px;
    color: #817970;
    font-size: 11px;
}

.login-card {
    width: 100%;
    max-width: 360px;
    box-sizing: border-box;
    padding: 22px;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 30px rgba(40, 35, 31, .08);
}

.login-heading {
    color: #28231f;
    font-size: 19px;
    font-weight: 700;
    text-align: center;
}

.login-description {
    margin-top: 5px;
    margin-bottom: 18px;
    color: #817970;
    font-size: 11px;
    line-height: 1.5;
    text-align: center;
}

.login-form {
    width: 100%;
}

.login-field {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    gap: 9px;
    box-sizing: border-box;
    margin-bottom: 11px;
    padding: 0 12px;
    border: 1px solid #ded8d2;
    border-radius: 8px;
    background: #fff;
}

.login-field:focus-within {
    border-color: #d94b05;
}

.login-field .material-icons {
    flex-shrink: 0;
    color: #817970;
    font-size: 18px;
}

.login-field input {
    width: 100%;
    height: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: #28231f;
    font-family:
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        "Noto Sans Devanagari",
        sans-serif;
    font-size: 13px;
    line-height: normal;
    appearance: none;
}

.login-field input::placeholder {
    color: #9b938b;
    opacity: 1;
}

.login-button {
    width: 100%;
    height: 43px;
    min-height: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    padding: 0 15px;
    border: 0;
    border-radius: 8px;
    background: linear-gradient(90deg, #d94b05, #e65d08);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

.login-button:disabled {
    opacity: .65;
}

.login-back {
    margin-top: 17px;
    text-align: center;
    font-size: 11px;
}

.login-back a {
    color: #d94b05;
    font-weight: 600;
    text-decoration: none;
}
`;
export default framework7Component;